import { render, staticRenderFns } from "./RiskCheckManagement.vue?vue&type=template&id=925a8dcc&scoped=true"
import script from "./RiskCheckManagement.vue?vue&type=script&lang=js"
export * from "./RiskCheckManagement.vue?vue&type=script&lang=js"
import style0 from "./RiskCheckManagement.vue?vue&type=style&index=0&id=925a8dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925a8dcc",
  null
  
)

export default component.exports